// Nhóm "Ngân sách & an toàn" và "Trang quy định".
import { Input } from "antd";
import { faFileLines, faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import { Field, GroupCard, NumField } from "./xu-config-fields";

export function XuConfigBudgetCard({ config, set, onReset }) {
    return (
        <GroupCard
            id="xu-sec-budget" icon={faShieldHalved} tone="text-rose-500"
            title="Ngân sách & an toàn"
            description="Các van chặn để tránh phát Xu quá tay. Chạm ngân sách thì nhiệm vụ mới tạm dừng phát Xu (nhiệm vụ đã xong vẫn nhận được) và có báo Telegram."
            onReset={onReset}
        >
            <div className="flex flex-wrap gap-x-8">
                <NumField
                    label="Trần Xu mỗi người mỗi ngày"
                    unit="Xu"
                    min={1}
                    value={config.dailyCap}
                    onChange={(v) => set({ dailyCap: v })}
                    hint="Một người nhận tối đa bấy nhiêu Xu/ngày, phần vượt bị cắt."
                    example="3000 Xu"
                />
                <NumField
                    label="Hạn dùng của Xu"
                    unit="ngày"
                    min={1}
                    value={config.xuTtlDays}
                    onChange={(v) => set({ xuTtlDays: v })}
                    hint="Xu nhận được sẽ hết hạn sau số ngày này."
                />
                <NumField
                    label="Giữ thưởng lớn của tài khoản mới"
                    unit="ngày"
                    min={0}
                    max={365}
                    value={config.newUserLockDays}
                    onChange={(v) => set({ newUserLockDays: v })}
                    hint="Tài khoản chưa có đơn đã duyệt: thưởng ngày 7 và mốc chuỗi được giữ chờ tối đa bấy nhiêu ngày."
                />
            </div>
            <div className="flex flex-wrap gap-x-8">
                <NumField
                    label="Ngân sách Xu toàn hệ thống mỗi ngày"
                    unit="Xu"
                    value={config.budgetDaily}
                    onChange={(v) => set({ budgetDaily: v })}
                    emptyMeans="không giới hạn"
                />
                <NumField
                    label="Ngân sách Xu toàn hệ thống mỗi tháng"
                    unit="Xu"
                    value={config.budgetMonthly}
                    onChange={(v) => set({ budgetMonthly: v })}
                    emptyMeans="không giới hạn"
                />
            </div>
        </GroupCard>
    );
}

const PAGES = [
    ["checkin", "Quy định điểm danh"],
    ["missions", "Quy định nhiệm vụ"],
    ["rank", "Quy định hạng"],
    ["general", "Quy định chung về Xu"],
];

export function XuConfigRulesPagesCard({ config, set, onReset }) {
    return (
        <GroupCard
            id="xu-sec-pages" icon={faFileLines} tone="text-slate-500"
            title="Trang quy định"
            description="Trang giải thích luật chơi mở từ app. Tạo trang trong mục Trang HTML tự tạo, rồi dán phần đuôi địa chỉ vào đây."
            onReset={onReset}
        >
            {PAGES.map(([key, label]) => (
                <Field key={key} label={label} hint={key === "checkin" ? "Ví dụ: địa chỉ longhousee.net/trang/quy-dinh-diem-danh thì nhập quy-dinh-diem-danh. Để trống = không hiện." : undefined}>
                    <Input
                        style={{ maxWidth: 420 }}
                        addonBefore="/trang/"
                        value={config.rulesPages?.[key] || ""}
                        onChange={(e) => set({ rulesPages: { ...config.rulesPages, [key]: e.target.value.trim() } })}
                    />
                </Field>
            ))}
        </GroupCard>
    );
}
